export const endpoints = {
  map: "/map-search-results/",
  users: {
    me: "/users/me/",
    register: "/users/register/",
    login: "/users/login/",
    logout: "/users/logout/",
    changePassword: "/users/password/change/",
    reset: "/users/password/reset/",
    confirmReset: "/users/password/reset/confirm/",
    language: "/users/language/"
  },
  businessAddresses: "/business-addresses/",
  categories: "/companies/categories/",
  websites: "/websites/",
  wizard: {
    company: {
      categories: "/keywords/categories/",
      profile: "/companies/"
    },
    businessAddresses: {
      autocomplete: "/map-places/"
    },
    gus: "/gus/"
  },
  keywords: {
    company: "/keywords/",
    companyDelete: keywordId => `/keywords/${keywordId}/`
  },
  competition: {
    default: "/companies/",
    companyCompetition: "/company-competition/",
    mapCompetitionList: "/map-search-competition/",
    limitManagement: "competitors-limits-management/"
  },
  locations: {
    suggested: "/keywords/suggested-locations/",
    rejected: "/keywords/rejected-locations/"
  },
  limits: {
    facilities: "/facilities-limits-management/",
    deleteFacility: id => `/facilities-limits-management/${id}/`,
    members: "/members-limits-management/",
    deleteMember: id => `/members-limits-management/${id}/`,
    keywords: "/keywords-limits-management/",
    deleteKeyword: id => `/keywords-limits-management/${id}/`,
    tags: "/tags-limits-management/",
    deleteTag: id => `/tags-limits-management/${id}/`,
    competitors: "/competitors-limits-management/",
    deleteCompetitor: id => `/competitors-limits-management/${id}/`
  },
  periodicRankings: "/periodic-rankings/",
  periodicRankingsTable: "/periodic-rankings-table/",
  periodicRankingsTableExport: "/periodic-rankings-table/export/",
  reportExportStatus: exportId => `/report-export/${exportId}/`,
  reportExportDownload: exportId => `/report-export/${exportId}/download/`,
  periodicRankingsTableSummary: "/periodic-rankings-table/summary/",
  compareReviews: "/compare/reviews/",
  comparePosts: "/compare/posts/",
  searchLocations: "/search-locations/",
  scores: "/scores/",
  competitionScores: "/competition-scores/",
  avgGMBRatings: "/avg-google-my-business-ratings/",
  avgMapSearchResult: "/avg-map-search-results/",
  subscriptionVouchers: "/subscription-vouchers/",
  facilities: "/facilities/",
  facilitiesCities: "/facilities-cities/",
  facilitiesGroups: "/facilities-groups/",
  facilitiesLabels: "/facilities-labels/",
  facilitiesUpdateStatuses: "/facilities-update-statuses/",
  facilitiesBulkEdit: "/facilities-bulk-edit/",
  facilitiesExport: "/facilities-export/",
  facilitiesImport: "/facilities-import/",
  facilitiesLimitsManagement: "/facilities-limits-management/",
  osmSettings: "/osm-settings/",
  googleOAuth: "/google-oauth-accounts/",
  gmbProfilePlaces: "/gmb-profiles/",
  gmbSearch: "/gmb-search/",
  gmbLocationCreate: "/gmb-location-create/",
  gmbLocationImports: "/gmb-location-imports/",
  companySubscriptions: "/company-subscriptions/",
  gmbInsights: "/gmb-insights-v2/",
  gmbInsightsExport: "/gmb-insights-v2/export/",
  gmbInsightsOld: "/gmb-insights/",
  gmbPost: postId => `/gmb-local-posts/${postId}/`,
  gmbPosts: "/gmb-local-posts/",
  gmbPostsSchedule: "/gmb-local-posts-schedule/",
  gmbPostsScheduleCalendar: "/gmb-local-posts-schedule/calendar/",
  gmbPostScheduled: postId => `/gmb-local-posts-schedule/${postId}/`,
  gmbPostsInsights: "/gmb-local-posts-insights/",
  gmbPostsFacilities: postId => `/gmb-local-posts/${postId}/facilities/`,
  gmbMediaFacilities: mediaId => `/gmb-media/${mediaId}/facilities/`,
  gmbPostsStoreLocator: postId => `/gmb-local-posts/${postId}/store-locator/`,
  gmbMedia: "/gmb-media/",
  gmbMediaId: id => `/gmb-media/${id}/`,
  gmbMediaStoreLocator: id => `/gmb-media/${id}/store-locator/`,
  gmbMediaStorage: "/gmb-media-storage/",
  gmbMediaTypes: "/gmb-media-types/",
  reviews: "/gmb-reviews/",
  reviewsSearch: "/gmb-reviews-search/",
  phrasesGroups: "/phrases-groups/",
  phrasesGroupDetails: id => `/phrases-groups/${id}/`,
  phrases: "/phrases/",
  phrase: id => `/phrases/${id}/`,
  reviewsBulkTag: "/gmb-reviews/bulk-tag/",
  reviewsExport: "/gmb-reviews/export/",
  reviewsReply: postId => `/gmb-reviews/${postId}/reply/`,
  reviewsBulkReply: "/gmb-reviews-bulk-reply/",
  reviewsTemplateBulkReply: "/gmb-reviews-template-bulk-reply/",
  reviewsStats: "/gmb-reviews-stats/",
  reviewsStatsTable: "/gmb-reviews-stats-table/",
  generateReviewReply: (companyId, gmbReviewId, userId) =>
    `review-reply/generate-review-reply/${companyId}/${gmbReviewId}/${userId}/`,
  aiReplyLimit: `/ai-review-reply-limit/`,
  aiReviewReplyConfig: "/ai-review-reply-config/",
  reviewsReplyCategories: "/review-reply-categories/",
  reviewsReplyCategory: categoryId => `/review-reply-categories/${categoryId}/`,
  reviewsReplyTemplates: "/review-reply-templates/",
  reviewsReplyTemplate: templateId => `/review-reply-templates/${templateId}/`,
  reviewsTags: reviewId => `/gmb-reviews/${reviewId}/tags/`,
  reviewTagCategory: (reviewId, categoryId) =>
    `/gmb-reviews/${reviewId}/tags/${categoryId}/`,

  reviewsNote: reviewId => `/gmb-reviews/${reviewId}/notes/`,
  gmbAttributes: "/gmb-attributes/",
  gmbMoreHours: "/gmb-more-hours/",
  gmbExternalChanges: "/gmb-external-changes/",
  gmbExternalChange: changeId => `/gmb-external-changes/${changeId}/`,
  gmbExternalChangesGroupAction: "/gmb-external-changes-bulk-edit/",
  gmbExternalChangesSettings: "/gmb-external-changes-settings/",
  gmbExternalChangesProtectionSummary:
    "/gmb-external-changes/protection-summary/",
  gmbExternalChangesReject: "/gmb-external-changes/reject/",
  gmbServicesList: "/gmb-service-types/",
  gmbServicesListFreeForm: "/gmb-service-types/free-form/",
  updateGmbExternalChangesSettings: id =>
    `/gmb-external-changes-settings/${id}/`,
  dashboardReviewsStats: "/dashboard-reviews-stats/",
  dashboardInsights: "/dashboard-insights-v2/",
  dashboardInsightsOld: "/dashboard-insights/",
  dashboardGmbAddressesStats: "/dashboard-gmb-addresses-stats/",
  dashboardLocalPostsStats: "/dashboard-local-posts-stats/",
  companyMembers: companyId => `/companies/${companyId}/members/`,
  companyParent: companyId => `/companies/${companyId}/parent/`,
  companyMembersLimitsManagement: "/members-limits-management/",
  enterpriseInvitation: "/invitations/enterprise/",
  acceptInvitation: "/invitations/accept/",
  resendInvitation: "/invitations/resend/",
  companyTags: "/tags/",
  companyTag: tagId => `/tags/${tagId}/`,
  mapsIntegration: "/maps-integration/",
  storeLocator: {
    config: "/store-locator/config/",
    defaultFaq: "/store-locator/faq/",
    defaultFaqById: id => `/store-locator/faq/${id}/`,
    facilityFaq: facilityId => `/store-locator/${facilityId}/faq/`,
    facilityFaqItem: (facilityId, itemId) =>
      `/store-locator/${facilityId}/faq/${itemId}/`,
    configCompany: companyId => `/store-locator/config/${companyId}/`,
    facilities: "/store-locator/config/facilities/",
    facilitiesGroups: "/store-locator/config/facilities-groups/",
    extraInfo: facilityId => `/store-locator/extra-info/${facilityId}/`,
    extraInfoSections: facilityId =>
      `/store-locator/extra-info/${facilityId}/sections/`,
    extraInfoSection: (facilityId, sectionId) =>
      `/store-locator/extra-info/${facilityId}/sections/${sectionId}/`
  },
  analytics: {
    gmb: {
      summary: "/analytics/summary/",
      heatmap: "/analytics/heatmap/",
      ratingsPinnedTable: "/analytics-table/ratings-pinned/",
      ratingsDetailsTable: "/reviews-analytics-details-table/ratings/",
      ratingsTable: "/analytics-table/ratings/",
      sentimentTable: "analytics-table/sentiment/",
      sentimentDetailsChart: "reviews-analytics-details/sentiment/",
      sentimentAggregatedTable: "analytics-table/sentiment-aggregated/",
      sentimentAggregatedDetailsChart:
        "reviews-analytics-details/sentiment-aggregated/",
      averageRatingsPinnedTable: "/analytics-table/average-pinned/",
      averageRatingsTable: "/analytics-table/average/",
      averageAnalyticsDetailsTable: "/reviews-analytics-details-table/average/",
      averageAnalyticsDetailsTableAll:
        "/reviews-analytics-details-table/average-without-category/",
      ratingsAnalyticsDetailsTable: "/reviews-analytics-details-table/ratings/",
      ratingsAnalyticsDetailsTableAll:
        "/reviews-analytics-details-table/ratings-without-category/",
      averageRatingsDetailsChart: "/reviews-analytics-details/average/",
      averageRatingsDetailsChartAll:
        "/reviews-analytics-details/average-without-category/",
      countDetailsChart: "/reviews-analytics-details/count/",
      countDetailsChartAll:
        "/reviews-analytics-details/count-without-category/",
      averageRatingsDetailsTablePinned:
        "/reviews-analytics-details-table/average-pinned/",
      ratingsAnalyticsDetailsTablePinned:
        "/reviews-analytics-details-table/ratings-pinned/",
      categorizationStatistics: "/categorization-statistics/",
      categorizationCompanySettings: "/categorization-company-settings/"
    },
    rb: {
      summary: "/review-booster/analytics/summary/",
      heatmap: "/review-booster/analytics/heatmap/",
      averageRatingsPinnedTable:
        "/review-booster/analytics-table/average-pinned/",
      averageRatingsTable: "/review-booster/analytics-table/average/",
      ratingsPinnedTable: "/review-booster/analytics-table/ratings-pinned/",
      ratingsTable: "/review-booster/analytics-table/ratings/",
      sentimentAggregatedTable:
        "/review-booster/analytics-table/sentiment-aggregated/",
      sentimentTable: "/review-booster/analytics-table/sentiment/"
    }
  },
  reviewBooster: {
    reviews: "review-booster/reviews/",
    reviewBoosterSettings: "review-booster/review-booster-settings/",
    reviewBoosterLinksExport: key =>
      `review-booster/review-booster-settings/${key}/export-links/`,
    exportReviews: "review-booster/reviews/export/",
    reviewBoosterStatsExport: key =>
      `review-booster/review-booster-settings/${key}/export-statistics/`,
    reviewBoosterReviewCategory: (reviewId, categoryId) =>
      `/review-booster/reviews/${reviewId}/categories/${categoryId}/`,
    reviewBoosterReviewCategories: reviewId =>
      `/review-booster/reviews/${reviewId}/categories/`
  },
  countries: "countries/",
  facebook: {
    accounts: "facebook-accounts/",
    deleteAccount: id => `facebook-accounts/${id}/`,
    enablePages: "facebook-pages/enable/",
    deletePage: id => `facebook-pages/${id}/`,
    posts: "facebook-posts/",
    pages: "facebook-pages/"
  },
  googlePlay: {
    accounts: "google-play/oauth-accounts/",
    deleteAccount: id => `google-play/oauth-accounts/${id}/`,
    apps: "google-play/apps/",
    deleteApp: id => `google-play/apps/${id}/`
  },
  payments: {
    root: "payments/",
    latestPayment: "payments/latest/",
    plans: "plans/",
    pricePreview: "price-preview/",
    afterPayment: "after-payment/",
    initialChosenPlan: "initial-chosen-plan/",
    promotionCodes: "promotion-codes/",
    campaigns: campaignId => `campaigns/${campaignId}/`
  },
  questionsAndAnswers: {
    questions: "q-and-a/questions/",
    question: questionId => `q-and-a/questions/${questionId}/`,
    createAnswerForQuestion: questionId =>
      `q-and-a/questions/${questionId}/create-answer/`,
    answers: "q-and-a/answers/",
    answer: answerId => `q-and-a/answers/${answerId}/`
  },
  autoReplies: {
    reviews: "review-auto-replies/",
    accept: "review-auto-replies/accept/",
    reject: "review-auto-replies/reject/"
  },
  appleMaps: {
    accounts: "apple-maps/accounts/",
    accountById: id => `apple-maps/accounts/${id}/`,
    authorize: "apple-maps/accounts/authorize/"
  },
  invitationLink: "invitations/enterprise/free/"
};
